module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('rt-section', {
    attrs: {
      "title": _vm.title,
      "icon": "rt-base-account"
    }
  }, [_c('div', {
    attrs: {
      "slot": "btn"
    },
    slot: "btn"
  }, [_c('rt-search', {
    attrs: {
      "more": false
    },
    on: {
      "on-search": _vm.search
    },
    model: {
      value: (_vm.queryValue),
      callback: function($$v) {
        _vm.queryValue = $$v
      },
      expression: "queryValue"
    }
  })], 1), _vm._v(" "), _c('rt-table', {
    ref: "table",
    staticClass: "rt-table-aside",
    class: {
      'is-single': !_vm.multiple
    },
    attrs: {
      "fetch": _vm.fetchData,
      "auto-height": false,
      "page-size": 10,
      "total-record": _vm.total,
      "row-key": _vm.getRowKeys,
      "height": _vm.computedHeight,
      "page-layout": "total, prev, pager, next"
    },
    on: {
      "select": _vm.select,
      "select-all": _vm.selectAll
    }
  }, _vm._l((_vm.displayFields), function(item, index) {
    return _c('rt-table-column', {
      key: index,
      attrs: {
        "prop": item.prop,
        "label": item.label,
        "width": item.width
      }
    })
  }), 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c75afc4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/lookup/rtLookupView.vue
// module id = 1496
// module chunks = 91